"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { ApiCommunityMembersSortOption } from "@/generated/models/ApiCommunityMembersSortOption";
const TITLE: Record<string, string> = {
  [ApiCommunityMembersSortOption.Display]: "Profile",
  [ApiCommunityMembersSortOption.Level]: "Level",
  [ApiCommunityMembersSortOption.Tdh]: "TDH",
  [ApiCommunityMembersSortOption.Xtdh]: "xTDH",
  [ApiCommunityMembersSortOption.Rep]: "REP",
  [ApiCommunityMembersSortOption.Cic]: "NIC"
};
export default function CommunityMembersTableHeaderSortableContent(t0) {
  const $ = _c(19);
  const {
    sort,
    activeSort,
    sortDirection,
    hoveringOption,
    isLoading
  } = t0;
  const isActive = sort === activeSort;
  const direction = isActive ? sortDirection : SortDirection.DESC;
  const [rotate, setRotate] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setRotate(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sortDirection) {
    t2 = [sortDirection];
    $[1] = sortDirection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== hoveringOption || $[4] !== isActive || $[5] !== sort) {
    t3 = () => setRotate(isActive && hoveringOption === sort);
    t4 = [hoveringOption, isActive, sort];
    $[3] = hoveringOption;
    $[4] = isActive;
    $[5] = sort;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  const showLoader = isLoading && isActive;
  const t5 = `${isActive ? "tw-text-primary-400" : "group-hover:tw-text-iron-200"} tw-transition tw-duration-300 tw-ease-out`;
  const t6 = TITLE[sort];
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== direction || $[12] !== isActive || $[13] !== rotate || $[14] !== showLoader) {
    t8 = showLoader ? <span className="tw-pl-2"><CircleLoader size={CircleLoaderSize.SMALL} /></span> : <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={direction} isActive={isActive} shouldRotate={rotate} /></span>;
    $[11] = direction;
    $[12] = isActive;
    $[13] = rotate;
    $[14] = showLoader;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}